export default __webpack_public_path__ + "static/media/peanutmm-image.0e961805.png";